// @flow
import * as React from 'react';

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default React.createContext(0);
